var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4799 8V10.3333C8.4799 11.62 9.52657 12.6667 10.8132 12.6667C12.0999 12.6667 13.1466 11.62 13.1466 10.3333V6.66667C13.1466 4.08667 11.0599 2 8.4799 2C5.8999 2 3.81323 4.08667 3.81323 6.66667V10.6667C3.81323 12.8733 5.60657 14.6667 7.81323 14.6667",
    stroke: "#70707B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttach);
export default __webpack_public_path__ + "static/media/attach.0ee77eed64334f7a0c888d7ce2d15367.svg";
export { ForwardRef as ReactComponent };